<template>
  <div>
    <router-link :to="to" :class="iconOnly ? 'd-flex align-items-center' : ''">
      <span v-if="iconOnly" class="icon" :class="iconClass" aria-hidden="true"></span>
      <span v-if="iconOnly" class="sr-only">{{ tcRequired ? $tc(i18nMessage, i18nCount) : $t(i18nMessage) }}</span>
      <span v-if="!iconOnly">{{ tcRequired ? $tc(i18nMessage, i18nCount) : $t(i18nMessage) }}</span>
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { RouteLocationRaw } from 'vue-router';

export default defineComponent({
  name: 'LinkDefault',
  props: {
    i18nMessage: {
      type: String,
      required: true
    },
    i18nCount: Number,
    to: {
      type: [String, Object] as PropType<RouteLocationRaw|string>,
      required: true
    },
    iconOnly:{
      type: Boolean,
      default: false,
    },
    iconClass:{
      type: String,
      default: 'icon-alle'
    }
  },
  methods: {
    tcRequired() {
      return typeof this.i18nCount === 'number';
    }
  }
});
</script>
